import { combineReducers } from 'redux';
import { testbutton } from './testbutton';
import { apiRandomDice } from './apiRandomDice';
import { valueSet } from './valueSet';

const rootReducer = combineReducers({
  testbutton,
  apiRandomDice,
  valueSet,
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js